export default (props) => (
  <svg width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M7.2 15a1 1 0 102 0V9.2H15a1 1 0 100-2H9.2V1a1 1 0 10-2 0v6.2H1a1 1 0 000 2h6.2V15z"
    ></path>
  </svg>
);
